import React, {Component} from 'react';
import SimpleSelect from 'components/atoms/dropdowns/simple-select';

class SelectTeamType extends Component {
    getOptions() {
        return {
            1: 'Same team',
            0: 'Opposing team',
        };
    }
    render() {
        return (
            <SimpleSelect
                className="form-control"
                value={this.props.value}
                options={this.getOptions()}
                onChange={this.props.onChange}
            />
        );
    }
}

export default SelectTeamType;
